module.exports = __webpack_public_path__ + "img/button_exit.367f4ee7.svg";